import styled from 'styled-components';


export const Wrapper = styled.div`
text-align:center;
margin-top:10rem;
font-family: "Inter";

h1{
font-weight: 600;
font-size: 50px;
letter-spacing: -0.04em;
}

p{
    font-size: 20px;
    letter-spacing: -0.02em;
    font-weight: 300;
    line-height: 32px;
}

span{
    color: var(--primary-brand);

}
`

